import { createStructuredSelector, createSelector } from "reselect";
import { defaultChipFilters } from "./components/DownloadCommon";
import { lastRebuildDtSelector } from "../../../app/ui/selectors";
import { siteDataSelector } from "../../../app/sitedata/selectors";

export const isFetchingSampleTypesSelector = state =>
  state.datatools.getIn(["download", "isFetchingSampleTypes"]);

export const sampleFilterIndexSelector = state =>
  state.datatools.getIn(["download", "sampleFilterIndex"]);

export const sampleCategoryTreeSelector = state =>
  state.datatools.getIn(["download", "sampleCategoryTree"]).toJS();

export const startDateFilterSelector = state =>
  state.datatools.getIn(["download", "startDateFilter"]);

export const endDateFilterSelector = state =>
  state.datatools.getIn(["download", "endDateFilter"]);

export const displayColumnsSelector = state =>
  state.datatools.getIn(["download", "displayColumns"]);

export const dropDownOptionsSelector = state =>
  state.datatools.getIn(["download", "dropDownOptions"]).toJS();

export const filteredDownloadDataSelector = state =>
  state.datatools.getIn(["download", "filteredDownloadData"]);

export const dropDownOptionsLoadingSelector = state =>
  state.datatools.getIn(["download", "dropDownOptionsLoading"]);

export const isFetchingDisplayColumnsSelector = state =>
  state.datatools.getIn(["download", "isFetchingDisplayColumns"]);

export const sampleOptionsSelector = state =>
  state.datatools.getIn(["download", "sampleOptions"]).toJS();

export const recordCountSelector = state =>
  state.datatools.getIn(["download", "recordCount"]);

export const previewSelector = state =>
  state.datatools.getIn(["download", "preview"]).toJS();

export const previewRowCountSelector = state =>
  state.datatools.getIn(["download", "previewRowCount"]);

export const isFetchingRecordCountSelector = state =>
  state.datatools.getIn(["download", "isFetchingRecordCount"]);

export const sampleMetaDataSelector = state =>
  state.datatools.getIn(["download", "sampleMetaData"]).toJS();

export const isFetchingMetadataSelector = state =>
  state.datatools.getIn(["download", "isFetchingMetaData"]);

export const isFetchingMapDataSelector = state =>
  state.datatools.getIn(["download", "isFetchingMapData"]);

export const columnNamesSelector = state =>
  state.datatools.getIn(["download", "columnNames"]).toJS();

export const isFetchingPreviewSelector = state =>
  state.datatools.getIn(["download", "isFetchingPreview"]);

export const appDrawerOpenSelector = state =>
  state.datatools.getIn(["ui", "appDrawerOpen"]);

export const autocompleteSelector = state =>
  state.datatools.getIn(["download", "autocomplete"]);

export const isFetchingAutoCompleteTreeSelector = state =>
  state.datatools.getIn(["download", "isFetchingAutoCompleteTree"]);

export const sampleFilterSelector = state =>
  state.datatools.getIn(["download", "sample"]).toJS().view_name;

export const displayFilterSelector = state => {
  const sample = state.datatools.getIn(["download", "sample"]).toJS();
  if (!sample.display_filters) sample.display_filters = defaultChipFilters;
  return sample.display_filters.map(obj => obj.field);
};

export const filtersWithDropDownsSelector = state => {
  const sample = state.datatools.getIn(["download", "sample"]).toJS();
  if (!sample.display_filters) sample.display_filters = defaultChipFilters;
  return sample.display_filters
    .filter(obj => obj.dropdown)
    .map(obj => obj.field);
};

export const sampleSelector = state =>
  state.datatools.getIn(["download", "sample"]).toJS();

export const lastApiQuerySelector = state =>
  state.datatools.getIn(["download", "lastApiQuery"]);

export const navDrawerChangedSelector = state =>
  state.datatools.getIn(["download", "navDrawerChanged"]);

export const isFetchingSamplesSelector = state =>
  state.datatools.getIn(["download", "isFetchingSamples"]);

export const filterChangedSelector = state =>
  state.datatools.getIn(["download", "filterChanged"]);

export const sampleIDSearchSelector = state =>
  state.datatools.getIn(["download", "sampleIDSearch"]).toJS();

export const showGridColumnPickerSelector = state =>
  state.datatools.getIn(["download", "showGridColumnPicker"]);

export const infiniteOffsetSelector = state =>
  state.datatools.getIn(["download", "infiniteOffset"]);

export const showPreviewSelector = state =>
  state.datatools.getIn(["download", "showPreview"]);

export const isFetchingFileSelector = state =>
  state.datatools.getIn(["download", "isFetchingFile"]);

export const downloadRawHeadersSelector = state =>
  state.datatools.getIn(["download", "rawHeaders"]);

export const chipsSelector = state =>
  state.datatools.getIn(["download", "chips"]).toJS();

export const getchipTextSelector = state =>
  state.datatools.getIn(["download", "chipText"]).toJS();

export const downloadHasRehydratedSelector = state =>
  state.datatools.getIn(["download", "downloadHasRehydrated"]);

// Advanced search filter
export const advancedFiltersSelector = state =>
  state.datatools.getIn(["download", "advancedFilters"]).toJS();
export const showAdvancedSearchSelector = state =>
  state.datatools.getIn(["download", "showAdvancedSearch"]);

// Time Zone Selector
export const timeZoneSelector = state => {
  return state.datatools.getIn(["download", "timeZone"]).value;
};

export const showTimeZoneSelector = state =>
  state.datatools.getIn(["download", "showTimeZone"]);

// Advanced search filter
export const advancedFiltersValidSelector = state =>
  state.datatools
    .getIn(["download", "advancedFilters"])
    .toJS()
    .filter(filter => filter.col && filter.operator && filter.saved);

export const rawTreeSelector = createSelector(
  sampleFilterSelector,
  autocompleteSelector,
  (sampleType, autocomplete) =>
    autocomplete.get(sampleType) ? autocomplete.get(sampleType).toJS() : []
);

export const organizationSelector = state => state.organization;
export const workareaSelector = state => state.workarea;

export const filterOpenSelector = state =>
  state.datatools.getIn(["download", "filterOpen"]);

export const existingFormTextSelector = state =>
  state.datatools.getIn(["download", "existingFormText"]);

export const formHistorySelector = state =>
  state.datatools.getIn(["download", "formHistory"]);

export const formEditorUpdatedSelector = state => {
  return state.datatools.getIn(["download", "formEditorUpdated"]);
};

export default createStructuredSelector({
  isFetchingSampleTypes: isFetchingSampleTypesSelector,
  sampleFilterIndex: sampleFilterIndexSelector,
  sampleFilter: sampleFilterSelector,
  sampleOptions: sampleOptionsSelector,
  recordCount: recordCountSelector,
  isFetchingRecordCount: isFetchingRecordCountSelector,
  isFetchingMetaData: isFetchingMetadataSelector,
  isFetchingMapData: isFetchingMapDataSelector,
  columnNames: columnNamesSelector,
  preview: previewSelector,
  startDateFilter: startDateFilterSelector,
  endDateFilter: endDateFilterSelector,
  autocomplete: autocompleteSelector,
  isFetchingPreview: isFetchingPreviewSelector,
  previewRowCount: previewRowCountSelector,
  sampleCategoryTree: sampleCategoryTreeSelector,
  sample: sampleSelector,
  displayColumns: displayColumnsSelector,
  isFetchingDisplayColumns: isFetchingDisplayColumnsSelector,
  lastApiQuery: lastApiQuerySelector,
  sampleIDSearch: sampleIDSearchSelector,
  filteredDownloadData: filteredDownloadDataSelector,
  appDrawerOpen: appDrawerOpenSelector,
  navDrawerChanged: navDrawerChangedSelector,
  isFetchingSamples: isFetchingSamplesSelector,
  advancedFilters: advancedFiltersSelector,
  showAdvancedSearch: showAdvancedSearchSelector,
  showTimeZone: showTimeZoneSelector,
  timeZone: timeZoneSelector,
  advancedFiltersValid: advancedFiltersValidSelector,
  filterChanged: filterChangedSelector,
  showGridColumnPicker: showGridColumnPickerSelector,
  infiniteOffset: infiniteOffsetSelector,
  showPreview: showPreviewSelector,
  isFetchingFile: isFetchingFileSelector,
  downloadRawHeaders: downloadRawHeadersSelector,
  chips: chipsSelector,
  chipText: getchipTextSelector,
  downloadHasRehydrated: downloadHasRehydratedSelector,
  dropDownOptions: dropDownOptionsSelector,
  dropDownOptionsLoading: dropDownOptionsLoadingSelector,
  displayFilter: displayFilterSelector,
  filtersWithDropDowns: filtersWithDropDownsSelector,
  autoCompleteTree: rawTreeSelector,
  isFetchingAutoCompleteTree: isFetchingAutoCompleteTreeSelector,
  sampleMetaData: sampleMetaDataSelector,
  lastRebuildDt: lastRebuildDtSelector,
  organization: organizationSelector,
  workarea: workareaSelector,
  filterOpen: filterOpenSelector,
  siteData: siteDataSelector,
  existingFormText: existingFormTextSelector,
  formHistory: formHistorySelector,
  formEditorUpdated: formEditorUpdatedSelector
});
